import React, { useState } from "react";
import JobTypeListing from "../listing";
import RecurringFilters from "./filters";
import { TypeStatsSection } from "../components/type-stats-section";

export default function RecurringJobs() {

  const [filters,setFilters]=useState({})
  

  return (
    <JobTypeListing 
      type="recurring" 
      title="Recurring Jobs" 
      filters={RecurringFilters}
     onFiltersChange={setFilters}
      renderContent={() => (
        <TypeStatsSection jobType="recurring" filters={filters} />
      )}
    />
  );
}
